module.exports = __webpack_public_path__ + "img/procedural_growth.823e1d07.gif";